import { reactive } from 'vue';
import { Modal } from 'bootstrap';

const state = reactive({
  modals: {},
});

/**
 * モーダルを登録
 *
 * @param {string} name
 * @param {Function} onOpen
 * @param {Function} onClose
 * @param {HTMLElement} modalDOM
 */
export function setModal(name, onOpen, onClose, modalDOM) {
  const modal = new Modal(modalDOM);
  modalDOM.addEventListener('show.bs.modal', onOpen);
  modalDOM.addEventListener('hide.bs.modal', onClose);
  state.modals[name] = {
    modal,
    onOpen,
    onClose,
    modalDOM,
  };
}

/**
 * モーダルを削除
 *
 * @param {String} name
 */
export function unsetModal(name) {
  if (state.modals[name]) {
    const { modalDOM, onOpen, onClose } = state.modals[name];
    modalDOM.removeEventListener('show.bs.modal', onOpen);
    modalDOM.removeEventListener('hide.bs.modal', onClose);
    delete state.modals[name];
  }
}

/**
 * 使用するモーダルの名前を引数に取り、そのモーダルを開閉する関数を返す
 *
 * @param {String} name
 * @returns {{openModal: openModal, closeModal: closeModal}}
 */
export default function useModal(name) {
  const openModal = () => {
    const { modal } = state.modals[name];
    modal.show();
  };

  const closeModal = () => {
    const { modal } = state.modals[name];
    modal.hide();
  };

  return {
    openModal,
    closeModal,
  };
}
